import { Component , OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Router , ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit{
    constructor(private messageService: MessageService , public router: Router , private route: ActivatedRoute) {}

    email: string | undefined;
    password: string | undefined;
    visible: boolean = false;
    isLogin: boolean = false;

    check_email: string = "example@gmail.com";
    check_password: string = "1234";
    username: string | undefined = "John Doe";

    items: MenuItem[] = [];

    ngOnInit(): void {
      this.items = [
        {
          label: 'Home',
          icon: 'icon home',
          routerLink: 'home',
          styleClass: 'menuitem',
          routerLinkActiveOptions: { exact: false },
  
        },
        {
          label: 'Map',
          icon: 'icon map',
          routerLink: 'map',
          styleClass: 'menuitem'
        },
        {
          label: 'Data Scraping',
          icon: 'icon web-scraping',
          routerLink: 'web-scraping',
          styleClass: 'menuitem'
        },
        {
          label: 'Import Dictionary',
          icon: 'icon dictionary',
          routerLink: 'import-dictionary',
          styleClass: 'menuitem'
        },
        {
          label: 'GeoCode',
          icon: 'icon map',
          routerLink: 'geocode',
          styleClass: 'menuitem'
        },
        {
          styleClass: 'separator',
          disabled: true
        },
        {
          label: 'View Solr Data',
          icon: 'icon solr',
          routerLink: 'search',
          styleClass: 'menuitem'
        },
        {
          label: ' View Real Estate Data',
          icon: 'icon estate',
          routerLink: 'eatate',
          styleClass: 'menuitem'
        },
        {
          label: 'NLP',
          icon: 'icon nlp',
          routerLink: 'nlp',
          styleClass: 'menuitem'
        },

        // {
        //   styleClass: 'separator',
        //   disabled: true
        // },
        // {
        //   label: 'Experimental',
        //   items: [
        //     {
        //       label: 'Social Media',
        //       icon: 'icon web-scraping',
        //       routerLink: 'social-media',
        //       styleClass: 'menuitem'
        //     }
        //   ]
        // }
      ]
    }

    showDialog() {
        this.visible = true;
    }

    closeDialog() {
        if (this.email === this.check_email && this.password === this.check_password) {
          this.messageService.clear();
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Success',   
            detail: 'Login successful!',
            life: 3000 
          })
          setTimeout(() => {
              this.visible = false;
              this.email = "";
              this.password = "";
              this.isLogin = true;
          }, 3500);
        } else {  
          this.messageService.clear();
          this.messageService.add({ 
            severity: 'error',
            summary: 'Error',
            detail: 'Your email or password is wrong.' ,
            life: 3000
          });
        }
    }

    navigateSolr() {
      this.router.navigateByUrl('/search;input=*');
    }

    logout() {
      this.isLogin = false;
    }

    onMapClick() {

    }
}
